var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7559 3.25125L14.5825 2.42462L15.5841 3.4262L14.1667 4.845V12.75C14.1667 13.1257 14.0174 13.4861 13.7518 13.7517C13.4861 14.0174 13.1257 14.1667 12.75 14.1667V12.75H11.3334V14.1667H4.84431L3.4234 15.5876L2.42181 14.586L3.25127 13.7558C3.2489 13.7535 3.24654 13.7511 3.24419 13.7487L5.66669 11.3333L12.75 4.25L13.7488 3.24416L13.7559 3.25125ZM11.22 7.79166H12.75V6.26095L11.22 7.79166ZM11.3334 5.67375L11.3404 5.66666H11.3334V5.67375ZM4.25002 10.7454L2.83336 12.1621V4.25C2.83336 3.87427 2.98261 3.51394 3.24829 3.24826C3.51396 2.98259 3.8743 2.83333 4.25002 2.83333V4.25H5.66669V2.83333H12.1621L5.78711 9.20833H4.25002V10.7454ZM4.25002 5.66666V7.79166H5.66669V5.66666H4.25002ZM12.75 11.3333V9.20833H11.3334V11.3333H12.75Z",
    fill: "#437CF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVideo);
export default __webpack_public_path__ + "static/media/no_video.46faf53306079a5db6decccdc3e1ae3c.svg";
export { ForwardRef as ReactComponent };